// Antipattern - maitaining a hand-coded type when the back end should
// provide the official API client w/type definitions
export const unsubscribeLinkTypes = {
  RELEVANT: 'RELEVANT',
  STOP_GETTING_MESSAGES: 'STOP_GETTING_MESSAGES',
  PREFER_LESS: 'PREFER_LESS',
} as const;

export type UnsubscribeLinkType =
  (typeof unsubscribeLinkTypes)[keyof typeof unsubscribeLinkTypes];

// when the user has disabled the unsubscribe link in their preferences
export const nullUnsubscribeLinkType = {
  NO_UNSUBSCRIBE_LINK: 'NO_UNSUBSCRIBE_LINK',
} as const;

export type NullUnsubscribeLinkType =
  (typeof nullUnsubscribeLinkType)[keyof typeof nullUnsubscribeLinkType];

export type AllUnsubscribeLinkTypes =
  | UnsubscribeLinkType
  | NullUnsubscribeLinkType;

export type UnsubscribeNullState = {
  loaded: boolean;
  locale: string | null;
  language: string | null;
  unsubscribeLinkType: AllUnsubscribeLinkTypes;
};

export type UnsubscribeEditOnConfirmArgs = {
  linkType: AllUnsubscribeLinkTypes;
  locale: string;
  language: string;
};

export type UnsubscribeEditProps = {
  unsubscribeData: {
    linkType: UnsubscribeLinkType;
    locale: string;
    open: boolean;
    selectedLang: string | null;
  };
  onConfirm: (args: UnsubscribeEditOnConfirmArgs) => void;
};

export type UnsubscribeReadyToRenderState = {
  loaded: boolean;
  locale: string;
  language: string | null;
  unsubscribeLinkType: UnsubscribeEditProps['unsubscribeData']['linkType'];
};

export type UnsubscribeViewModel =
  | UnsubscribeNullState
  | UnsubscribeReadyToRenderState;

export const I18N_LINK_TEXT_KEY_BASE = 'hubspot-prosemirror.unsubscribeLink.';

export const DATA_ATTRIBUTE = 'data-hs-unsubscribe';
export const LOCALE_DATA_ATTRIBUTE = 'data-hs-unsubscribe-locale';
export const LINK_TYPE_ATTRIBUTE = 'data-hs-linktype';
export const LOCALE_LANGUAGE_ATTRIBUTE = 'data-hs-unsubscribe-language';
export const LINK_TOKEN = '{{ unsubscribe_link }}';
export const LINK_TEXT_ATTRIBUTE = 'data-hs-link-text';
export const LINK_URL_TEXT_ATTRIBUTE = 'data-hs-link-url-text';
